import makeRequest from "../api/makeRequest";
import url from "../api/urls";
import { RequstMethods } from "../api/requestMethode";
export class CompanyService {
  static async getCompany(page = 1, limit = 10, search = "") {
    return await makeRequest(
      url.company.getCompany(page, limit, search),RequstMethods.GET
    );
  }
  static async createCompany(payload: any) {
  return makeRequest(
    url.company.createCompany,RequstMethods.POST,
    payload
  );
}
 static async getCompanyById(companyId: string) {
    return makeRequest(
      url.company.getDetails(companyId),RequstMethods.GET
    );
  }
static async updateCompany(id: string, payload: any) {
  return makeRequest(
    url.company.updateCompany(id),RequstMethods.PUT,
    payload
  );
}

 static async updateCompanyStatus(companyId: string, payload: any) {
    return makeRequest(
      url.company.updateStatus(companyId),
      RequstMethods.PUT,
      payload,
    );
  }


  static async deletecompany(companyId: string) {
    return makeRequest(
      url.company.delete(companyId),RequstMethods.DELETE
    );
  }

  static async getAiFeatures() {
  return makeRequest(
    url.company.aiFeatures,RequstMethods.GET
  );
}

static async getAIFeatures() {
  return makeRequest(
    url.company.aiFeatures,RequstMethods.GET
  );
}

 static async resetPassword(companyId: string, payload: any) {
  return makeRequest(
    url.company.resetPassword(companyId),RequstMethods.PUT,payload
  );
}

static async makeBucketPublic(companyId: string) {
  return makeRequest(
    url.company.makeBucketPublic(companyId),RequstMethods.PUT
  );
}

static async makeBucketPrivate(companyId: string) {
  return makeRequest(
    url.company.makeBucketPrivate(companyId),RequstMethods.PUT
  );
}

static async getAllPlan(page = 1, limit = 10, search = "") {
  return makeRequest(url.plan.getAllPlan(page, limit, search),RequstMethods.GET)
}

static async createPlan(payload: any) {
  return makeRequest(url.plan.createPlan,RequstMethods.POST,payload);
}

static async getPlanDetails(id: string) {
  return await makeRequest(
    url.plan.getPlanDetails(id),RequstMethods.GET
  );
}

static async updatePlan(id: string, data: any) {
  return await makeRequest(
    url.plan.updatePlan(id),RequstMethods.PUT,
    data
  );
}

static async updatePlanStatus(id: string, payload: any) {
    return makeRequest(
      url.plan.updateStatus(id),
      RequstMethods.PUT,
      payload,
    );
  }



 static async getAllSubscriptions(page = 1, limit = 10) {
  return makeRequest(
    url.subscription.getAll(page, limit),RequstMethods.GET
  );
}
  static async updateSubscriptionStatus(id: string, payload: any) {
    return makeRequest(
      url.subscription.updateStatus(id),RequstMethods.PUT,
      payload
    );
  }

  static async getSubscriptionById(id: string) {
    return makeRequest(
      url.subscription.getById(id),RequstMethods.GET
    );
  }

   static async updateSubscription(id: string, data: any) {
    return makeRequest(
      url.subscription.update(id),RequstMethods.PUT,
      data
    );
  }

  static async getCompanySubscription(companyId: string, status: string = 'active') {
    return await makeRequest(
      `${url.company.getSubscription}/${companyId}?status=${status}`,
      RequstMethods.GET
    );
  }

  static async getPlansForDropdown() {
    return await makeRequest(url.plan.plansForDropdown, RequstMethods.GET);
  }

  static async subscribePlan(payload:any){
    return await makeRequest(url.company.subscribeSubscription, RequstMethods.POST, payload);
  }
  
  
}